////
/// ============================================================================
/// COMPONENT / Swiper Popular
/// ============================================================================
///
/// @group components
////

import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

export default () => {
    let element = document.querySelector('.js-popular');

    if (!element) {
        return;
    }

    const breakpoint = window.matchMedia('(min-width:1024px)');

    let swiper;

    const breakpointChecker = function () {
        if (breakpoint.matches === true) {
            enableSwiper();
        } else {
            if (swiper !== undefined) {
                swiper.destroy(true, true);
            }
        }

        element.classList.toggle("is-destroy", !breakpoint.matches);
    };

    const enableSwiper = function () {
        swiper = new Swiper(element, {
            modules: [Autoplay, Pagination],
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 20,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            breakpoints: {
                768: {
                    spaceBetween: 24,
                },
                1200: {
                    spaceBetween: 32,
                },
            },
        });
    };

    breakpoint.addListener(breakpointChecker);

    breakpointChecker();
};
